import Section from "../Section"
import { split, support } from "../utils"
import gsap from "gsap";
import { CustomEase } from "gsap/CustomEase"
gsap.registerPlugin(CustomEase)

class AboutText extends Section {
  constructor(opts) {
    super(opts)

    if (support.touch) return

    this.splitText = this.splitText.bind(this)

    this.DOM = this.getDOM()

    this.splitText()

    this.animated = false

    this.textMask = this.createTextMaskTL()

    window.addEventListener("resize", this.splitText)
  }

  getDOM() {
    return {
      headline: this.section.querySelector("h2"),
      subheadline: this.section.querySelector(".about__sub-headline"),
      description: this.section.querySelector(".about__description"),
    }
  }

  createTextMaskTL() {
    const tl = new gsap.timeline({ paused: true })

    tl
      .fromTo(this.splitHeadline, { y: "100%" }, { y: "0%", duration: 1.2, ease: "customEase" })
      .fromTo(this.splitSubheadline, { y: "100%" }, { y: "0%", duration: 1.2, ease: "customEase" }, "-=.9")
      .fromTo(this.splitDescription, { y: "100%" }, { y: "0%", duration: 1.2, ease: "customEase" }, "-=.9")

    return tl
  }

  run(opts) {
    super.run(opts)

    if (this.data.progress > 0.1 && !this.animated) {
      this.animated = true
      this.textMask.play()
    }
  }

  splitText() {
    this.headline && this.headline.revert()
    this.subheadline && this.subheadline.revert()
    this.description && this.description.revert()

    this.headline = split({
      contentType: "headline",
      textElement: this.DOM.headline
    })

    this.subheadline = split({
      contentType: "paragraph",
      textElement: this.DOM.subheadline,
    })

    this.description = split({
      contentType: "paragraph",
      textElement: this.DOM.description,
    })

    this.splitHeadline = this.headline.lines.map(line => line.querySelectorAll(".line-container"))
    this.splitSubheadline = this.subheadline.lines.map(line => line.querySelectorAll(".line-container"))
    this.splitDescription = this.description.lines.map(line => line.querySelectorAll(".line-container"))
  }

  resize() {
    if (support.touch) return
    gsap.set([this.splitHeadline, this.splitSubheadline, this.splitDescription], { clearProps: "all" })
    this.splitText()
    this.data.height = this.section.getBoundingClientRect().height
    if (this.animated) return
    this.textMask = this.createTextMaskTL()
  }

  destroy() {
    this.headline.revert()
    this.subheadline.revert()
    this.description.revert()
  }
}

export default AboutText